import type { SymbolDefinition } from "../types.ts";

export const motor3p: SymbolDefinition = {
  id: "ep-motor-3p",
  familyKey: "motor",
  deviceKind: "motor",
  version: "0.1.0",
  label: { sv: "Motor 3-fas", en: "3-phase motor" },
  description: { sv: "Trefasig asynkronmotor.", en: "Three-phase induction motor." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="24" cy="28" r="16"/>
      <text x="24" y="32" text-anchor="middle" font-size="10" fill="currentColor" stroke="none">M</text>
      <text x="24" y="42" text-anchor="middle" font-size="5" fill="currentColor" stroke="none">3~</text>
      <line x1="14" y1="12" x2="14" y2="2"/>
      <line x1="24" y1="12" x2="24" y2="2"/>
      <line x1="34" y1="12" x2="34" y2="2"/>
    </g>
  `,
  terminals: [
    { id: "U", kind: "phase", label: "U", position: "top", offset: 0.292 },
    { id: "V", kind: "phase", label: "V", position: "top", offset: 0.5 },
    { id: "W", kind: "phase", label: "W", position: "top", offset: 0.708 },
  ],
  designationPrefix: "M",
  searchKeywords: ["motor", "asynkron", "3-fas"],
};
